import { render } from "./ellipsis.vue?vue&type=template&id=06485624&scoped=true"
import script from "./ellipsis.vue?vue&type=script&lang=js"
export * from "./ellipsis.vue?vue&type=script&lang=js"

import "./ellipsis.vue?vue&type=style&index=0&id=06485624&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06485624"]])

export default __exports__